import type { CriterionDependenciesReadModel } from "@Criteria/Hierarchies/Domain/readmodels";

export class CriterionDeleterViewModel
{
    isOpen = false;

    criterionId: number | null = null;
    data: CriterionDependenciesReadModel | null = null;

    show(criterionId: number)
    {
        this.criterionId = criterionId;
        this.data = null;
        this.isOpen = true;
    }

    close()
    {
        this.isOpen = false;
        this.criterionId = null;
        this.data = null;
    }

    setData(data: CriterionDependenciesReadModel)
    {
        this.data = data;
    }
}
